import React from 'react';

import AddProductButton from '../../../../../../components/add-product-button/add-product-button';
import ProductListCardPromos from '../../../product-list-card-promos/product-list-card-promos';
import ProductListStaggeredCardAxle from '../product-list-staggered-card-axle/product-list-staggered-card-axle';

import { getPrioritizedArticleStatusProduct } from '../../../../../../shared/utils/product/product';

import { ProductData } from '../../../../../../shared/types/graphql-types';
import { ProductItem } from '../../../../../../shared/types/product';

import styles from './product-list-staggered-card-actions.scss';

interface ProductListStaggeredCardActionsProps {
  defaultQuantity?: number;
  onAddProductClick: (productItem: ProductItem) => void;
  onQuantityChange: (value: number) => void;
  onRearQuantityChange: (value: number) => void;
  product: ProductData;
  quantity: number;
  rearQuantity: number;
  totalQuantity: number;
}

function ProductListStaggeredCardActions(
  props: ProductListStaggeredCardActionsProps
) {
  const {
    defaultQuantity,
    onAddProductClick,
    onQuantityChange,
    onRearQuantityChange,
    product,
    quantity,
    rearQuantity,
    totalQuantity
  } = props;

  const { rearProduct } = product || {};
  const articleStatusProduct = getPrioritizedArticleStatusProduct(
    product,
    rearProduct
  );
  const showAddToCart = !articleStatusProduct?.addToCartDisabled;

  function handleQuantityChange(e, updatedValue) {
    onQuantityChange(updatedValue);
  }

  function handleRearQuantityChange(e, updatedValue) {
    onRearQuantityChange(updatedValue);
  }

  return (
    <div className={styles['container']}>
      <div className={styles['axles']}>
        <ProductListStaggeredCardAxle
          defaultQuantity={defaultQuantity}
          label="Front"
          onQuantityChange={handleQuantityChange}
          product={product}
          quantity={quantity}
          totalQuantity={totalQuantity}
        />
        {rearProduct && (
          <ProductListStaggeredCardAxle
            defaultQuantity={defaultQuantity}
            label="Rear"
            onQuantityChange={handleRearQuantityChange}
            product={rearProduct}
            quantity={rearQuantity}
            totalQuantity={totalQuantity}
          />
        )}
      </div>

      <div className={styles['promo']}>
        <ProductListCardPromos product={product} />
      </div>

      {showAddToCart && rearProduct && (
        <AddProductButton
          className={styles['add-to-btn']}
          onClick={onAddProductClick}
          productItem={{
            product,
            quantity,
            rearProduct,
            rearQuantity,
            totalQuantity
          }}
        />
      )}
    </div>
  );
}

export default ProductListStaggeredCardActions;
